import { render } from "./gameDetailPage.vue?vue&type=template&id=419163a0"
import script from "./gameDetailPage.vue?vue&type=script&lang=js"
export * from "./gameDetailPage.vue?vue&type=script&lang=js"

import "./gameDetailPage.vue?vue&type=style&index=0&id=419163a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__